import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import styled, { theme } from 'connect-dot-com-ui/components/Theme';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { H4 } from 'UIComponents/elements/headings';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
const BadgeCard = styled(UICardWrapper).withConfig({
  displayName: "Badge__BadgeCard",
  componentId: "aedj2u-0"
})(["padding:24px;margin-bottom:0 !important;flex-direction:row;align-items:center;height:100%;min-height:108px;&:hover{", "}"], props => props.$clickable && `box-shadow: 0 1px 10px 3px rgb(45 62 80 / 12%);`);
const BadgeIcon = styled.img.withConfig({
  displayName: "Badge__BadgeIcon",
  componentId: "aedj2u-1"
})(["height:60px;width:60px;margin-right:16px;"]);
export const EmptyBadge = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(BadgeCard, {
    style: {
      width: 'fit-content'
    },
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "hubspotCertification",
      size: 72,
      className: "m-right-4",
      color: theme.colors.BATTLESHIP
    }), /*#__PURE__*/_jsx(UIFlex, {
      justify: "center",
      direction: "column",
      children: children
    })]
  });
};
export const BadgeGrid = styled.div.withConfig({
  displayName: "Badge__BadgeGrid",
  componentId: "aedj2u-2"
})(["display:grid;column-gap:24px;row-gap:24px;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));", " @media (max-width:", "){grid-template-columns:1fr;}"], props => props.$noEarnedBadges && `grid-template-columns: 1fr;`, props => props.theme.sizes.GRID_BREAKPOINT_SMALL);

const BlankComponent = () => null;

const Badge = ({
  icon,
  title,
  earnedAt,
  href
}) => {
  return /*#__PURE__*/_jsx(UILink, {
    "data-test-id": "credential-card",
    href: href,
    use: "unstyled",
    external: true,
    ExternalIcon: BlankComponent,
    style: {
      cursor: href ? 'pointer' : 'unset'
    },
    children: /*#__PURE__*/_jsxs(BadgeCard, {
      $clickable: !!href,
      children: [icon ? /*#__PURE__*/_jsx(BadgeIcon, {
        src: icon
      }) : /*#__PURE__*/_jsx(UIIcon, {
        name: "hubspotCertification",
        size: 72,
        className: "m-right-4",
        color: theme.colors.BATTLESHIP
      }), /*#__PURE__*/_jsxs(UIFlex, {
        justify: "center",
        direction: "column",
        children: [/*#__PURE__*/_jsx(H4, {
          className: "m-bottom-0",
          children: title
        }), /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "connectDotCom.earnedDate",
          options: {
            date: /*#__PURE__*/_jsx(FormattedDateTime, {
              value: earnedAt,
              format: "ll"
            })
          }
        })]
      })]
    })
  });
};

export default Badge;